import { ReduxUtils } from '../../dependencies';

const asyncType = ReduxUtils.createAsyncType({
    modulePrefix: 'commonFilter',
});

export default asyncType({
    types: ['SET_FILTER_URL_PARAMS', 'SET_ORDER_URL_PARAM'],
});
